export default {
  name: 'control-bar'
}
